import { get } from 'lodash';
import { useFind } from 'api/APIHooks';

/**
 * Custom hook for fetching authorized spends with optional exclusions
 */
export const useAuthorizedSpends = ({
  feeScheduleProgram,
  person,
  requestedStartsAt,
  requestedEndsAt,
  excludeServiceAuthorizations,
  enabled = true,
  state,
}) => {
  const filters = {
    fee_schedule_program: feeScheduleProgram,
    person,
    requested_starts_at: requestedStartsAt,
    requested_ends_at: requestedEndsAt,
    ...(excludeServiceAuthorizations && { exclude_service_authorizations: excludeServiceAuthorizations }),
    ...(state && { state }),
  };

  const { data, isFetching } = useFind(
    'authorized_spend',
    filters,
    { queryConfig: { enabled, placeholderData: undefined } },
  );

  return {
    authorizedSpends: get(data, 'data.data', []),
    meta: get(data, 'data.meta', {}),
    isFetching,
  };
};
